import OwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Footer from '../../components/Layout/Footer';
import { Link, Routes, useNavigate } from 'react-router-dom';
import { deleteFromStorage, getFromStorage, logoutHelper, saveToStorage } from '../../utils/Helper';
import { StorageConstants } from '../../constants/Constants';
import { useEffect, useLayoutEffect, useState } from 'react';
import ApprovalPendingModel from '../../components/Model/ApprovalPendingModel';
import { useDispatch, useSelector } from 'react-redux';
import { GetProfileAction, HomePageCategory, ProfileGetCategoryAction } from '../../redux/Action/ProfileAction';
import { Config } from '../../config/Config';
import Spinner from '../../components/Spinner';
import { ImageContainer } from '../../constants/ImagesConstants';
import { FormattedMessage } from 'react-intl';
import LanguageSwitcher from '../../components/Layout/LanguageSwitcher';



const { TopLogoImage, HomeBannerImage, HomeImageOne, HomeImageTwo, HomeSliderCatOne, HomeSliderCatTwo, HomeSliderCatThree, HomeSliderCatFour, HomeSliderCatFive, HomeSliderCatSix, DownloadAppImage, HomePlayStore, HomeGooglePlay, FooterImage } = ImageContainer;

const options = {
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    responsive: {
        0: {
            items: 2,
            center: true
        },
        600: {
            items: 4
        },
        1000: {
            items: 5
        },
        1600: {
            items: 6
        }
    }
};

const Home = () => {

    const dispatch = useDispatch<any>();
    const profileData = useSelector((state: any) => state.GetProfileState);
    const categoryGet = useSelector((state: any) => state.HomePageCategoryState);
    const [payload, setPayload]: any = useState(null);

    useEffect(() => {
        if (Config?.IS_USER_LOGIN_TOKEN) {
            dispatch(GetProfileAction({ type: 1 }))
        }
    }, [])

    const navigate: any = useNavigate();



    useLayoutEffect(() => {
        if (profileData?.data?.data?.role_id == 1) {
            if (profileData?.data?.data?.is_profile_setup == 0 && profileData?.data?.data?.is_approved == 0) {
                navigate("/profile");
            }
            else if (profileData?.data?.data?.is_profile_setup == 1 && profileData?.data?.data?.is_approved == 0) {
                navigate("/complete-profile");
            }
            else if (profileData?.data?.data?.is_profile_setup == 2 && profileData?.data?.data?.is_approved == 0) {
                navigate("/");
            }

            else if (profileData?.data?.data?.is_profile_setup == 2 && profileData?.data?.data?.is_approved == 1) {
                // navigate("/dashboard");
                window.location.href = Config?.BASE_URL + "/dashboard"
            }
            else if (profileData?.data?.data?.is_profile_setup == 2 && profileData?.data?.data?.is_approved == 2) {
                navigate("/")
            }
            else if (profileData?.data?.data?.is_profile_setup == 0 && profileData?.data?.data?.is_approved == 3) {
                navigate("/profile");
            }
            else if (profileData?.data?.data?.is_profile_setup == 1 && profileData?.data?.data?.is_approved == 3) {
                navigate("/complete-profile");

            }
            else if (profileData?.data?.data?.is_profile_setup == 2 && profileData?.data?.data?.is_approved == 3) {
                navigate("/")
            }

        }
        else if (profileData?.data?.data?.role_id == 2) {
            navigate("/dashboard")
        }

    }, [profileData])




    useEffect(() => {
        if (profileData?.data?.data?.is_approved == 0 && profileData?.data?.data?.is_profile_setup == 2 || (profileData?.data?.data?.is_approved == 3 && profileData?.data?.data?.is_profile_setup == 2)) {
            setPayload("profile")
            const modalTrigger = document.getElementById('approval-model');
            if (modalTrigger) {
                modalTrigger.click();
            }
        }
    }, [profileData]);



    useEffect(() => {
        if (profileData?.status) {
            saveToStorage({ key: StorageConstants?.USER_DETAIL, value: profileData?.data?.data })
        }
    }, [profileData])

    useEffect(() => {
        if (Config?.IS_USER_LOGIN_TOKEN && profileData?.data?.data?.is_approved == 2) {
            setPayload("profile-rejected")
            const modalTrigger = document.getElementById('approval-model');
            if (modalTrigger) {
                modalTrigger.click();
            }
        }
    }, [profileData]);

    const [isLoadingData, setIsLoadingData] = useState(true);


    useEffect(() => {
        // window.addEventListener('storage', (event) => {
        //     if (event.key == 'user_details' && event.newValue === null) {

        //         window.location.href = Config?.url + '/login';
        //     }
        // });
        // const handleStorageChange = (event: any) => {
        //     if (event.key == 'user_details' && event.newValue == null) {
        //         // Redirect to the login page when 'user_details' is removed from localStorage
        //         window.location.href = `${Config?.url}/login`;
        //     }
        // };

        // window.addEventListener('storage', handleStorageChange);

        // return () => {
        //     window.removeEventListener('storage', handleStorageChange);
        // };




        setIsLoadingData(false);
    }, []);

    useEffect(() => {
        dispatch(HomePageCategory({}))
    }, [])
    if (isLoadingData || profileData.loading || categoryGet?.loading) {
        return <Spinner />;
    }

    const {
        is_profile_setup,
        is_approved
    } = profileData?.data?.data || {};

    const token = (
        is_profile_setup === 1 ||
        is_profile_setup === 2 ||
        is_approved === 0 ||
        is_approved === 2 ||
        is_approved === 3 ||
        (Config?.USER_DETAILS?.is_profile_setup !== 0 && Config?.IS_USER_LOGIN_TOKEN)
    );



    const handleLogin = () => {

        const token = getFromStorage({ key: StorageConstants?.IS_USER_LOGIN_TOKEN });
        if (!token) {
            deleteFromStorage({ key: StorageConstants?.USER_DETAIL });

            window.location.href = (Config?.BASE_URL || "") + "/login"
        }
    }

    const handleSignup = () => {
        const token = getFromStorage({ key: StorageConstants?.IS_USER_LOGIN_TOKEN });
        if (!token) {
            deleteFromStorage({ key: StorageConstants?.USER_DETAIL });
            // window.reload()
            // navigate('/login')
            window.location.href = (Config?.BASE_URL || "") + "/register"
        }
    }



    // useEffect(() => {
    // window.addEventListener('storage', (event) => {
    // if (event.key === 'user_details' && event.newValue === null) {

    //     window.location.href = Config?.url + '/login';
    // }
    // })
    // }, [])


    // useEffect(() => {
    //     const handleStorageChange = (event: any) => {
    //         if (event.key === 'user_details' && event.newValue === null) {
    //             // Redirect to the login page when 'user_details' is removed from localStorage
    //             // window.location.href = `${Config?.url}/login`;
    //         }
    //     };

    //     // Attach the event listener
    //     // window.addEventListener('storage', handleStorageChange);

    //     // // Cleanup the event listener when the component is unmounted
    //     // return () => {
    //     //     window.removeEventListener('storage', handleStorageChange);
    //     // };
    // }, []);


    // const handleSignup = () => {
    //     const token = getFromStorage({ key: StorageConstants?.IS_USER_LOGIN_TOKEN });
    //     if (!token) {
    //         deleteFromStorage({ key: StorageConstants?.USER_DETAIL });
    //         window.location.href = Config?.url + "/register"
    //     }
    // }


 

    if (profileData?.data?.data?.is_profile_setup == 2 && profileData?.data?.data?.is_approved == 1) {
        return <Spinner />
    }

    return (
        <>
            {/* {categoryGet?.loading ? <Spinner /> : ""} */}
            <header>

                <nav className="navbar navbar-expand-lg fixed-top">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="/"><img src={TopLogoImage} /></Link>
                        <div className='rightbtn d-flex align-items-center'>
                            <LanguageSwitcher className="me-2" variant="light" />
                            {
                                token != null || undefined ? <button type='button' className='btn btnwhite' onClick={logoutHelper}>  <FormattedMessage id="logout" /></button> :
                                    (
                                        <>
                                            {/* <Link className='btn btnwhiteOutline me-2' to={'/login'} >
                                                Login</Link> */}
                                            <Link className='btn btnwhiteOutline me-2' to={'/login'} onClick={handleLogin} >
                                                <FormattedMessage id="login" /> </Link>
                                            <Link className='btn btnwhite' to={'/register'} onClick={handleSignup} >
                                                <FormattedMessage id="sign_up" /></Link>
                                        </>
                                    )
                            }
                        </div>
                    </div>
                </nav>
            </header>
            <section className='banner'>
                <img src={HomeBannerImage} />
                <div className='hoverText'>
                    <div className='container'>
                        <h1>  <FormattedMessage id="Hair_Beauty_Salon" /></h1>
                        <p>  <FormattedMessage id="description_1" /><br />  <FormattedMessage id="description_2" /></p>
                    </div>
                </div>
            </section>

            <section>
                <div className='container'>
                    <div className='row gy-4 my-5 align-items-center'>
                        <div className='col-lg-5 offset-lg-1 order-lg-2 imgdask text-center'>
                            <img alt="" src={HomeImageOne} />
                        </div>
                        <div className='col-lg-6'>
                            <h2 className='title'><FormattedMessage id="title_1" /></h2>
                            <p><FormattedMessage id="description_3" /></p>
                        </div>

                    </div>
                    <div className='row gy-4 my-5 align-items-center'>
                        <div className='col-lg-5 imgdask text-center'>
                            <img alt="" src={HomeImageTwo} />
                        </div>
                        <div className='col-lg-6 offset-lg-1'>
                            <h2 className='title'><FormattedMessage id="title_2" /></h2>
                            <p><FormattedMessage id="description_4" /></p>
                        </div>

                    </div>
                    <div className='row gy-4 my-5 align-items-center'>
                        <div className='col-lg-5 offset-lg-1 order-lg-2 imgdask  text-center'>
                            <img alt="" src={HomeImageOne} />
                        </div>
                        <div className='col-lg-6'>
                            <h2 className='title'><FormattedMessage id="title_3" /></h2>
                            <p><FormattedMessage id="description_5" /></p>
                        </div>

                    </div>
                </div>

            </section>
            <section className='categorys py-5'>
                <OwlCarousel className="owl-theme"  {...options}>
                    {
                        categoryGet?.data?.data?.map((item: any) => {
 
                            return (
                                <>
                                    <div className='item'>
                                        <img src={item?.image_details?.file_path} />
                                        <h6>{item?.name ? item?.name : 'N/A'}</h6>
                                    </div>
                                </>
                            )
                        })
                    }

                </OwlCarousel>
            </section>
            <section className='downloadApp'>
                <div className='container text-center'>
                    <p className='subheading'><FormattedMessage id="downloads" /></p>
                    <h2><FormattedMessage id="for_bookings_download_app" /></h2>
                    <img className='my-5' alt="download" src={DownloadAppImage} />
                    <div className='storeImg d-flex gap-3'>
                        <img alt="app store" src={HomePlayStore} />
                        <img alt="play store" src={HomeGooglePlay} />
                    </div>
                </div>
            </section>
            <section className='footerBG'>
                <img src={FooterImage} />
            </section>

            <Footer />
            <a href="#approval-box" data-bs-toggle="modal" id="approval-model" style={{ display: 'none' }}>Open Modal</a>
            <ApprovalPendingModel type={payload} profile_data={profileData} />
        </>
    )
}
export default Home;
